export const getMatchIdFromSocketPayload = (payload) => (
  payload?.matchId ?? payload?.match_id ?? null
);

export const getFinalScoreFromCompletionPayload = (payload) => {
  const finalScore = payload?.final_score;
  if (
    finalScore &&
    typeof finalScore.home === 'number' &&
    typeof finalScore.away === 'number'
  ) {
    return { home: finalScore.home, away: finalScore.away };
  }

  if (
    typeof payload?.homeScore === 'number' &&
    typeof payload?.awayScore === 'number'
  ) {
    return { home: payload.homeScore, away: payload.awayScore };
  }

  return null;
};

export const getCompletionStatusFromPayload = (payload) => {
  const status = typeof payload?.status === 'string' ? payload.status.trim() : '';
  return status || 'completed';
};
